export default "__VITE_ASSET__Bygvku3y__"